module.exports = __webpack_public_path__ + "static/media/emma_02.ac578d9c.png";